// extracted by mini-css-extract-plugin
module.exports = {"socialLink":"Sosials_socialLink__ldfuk"};